import { DeviceStatusBar } from './DeviceStatusBar';

export interface IDisplayMetrics {
    screen: { width: number; height: number; }
    viewport: { width: number; height: number; }
    devicePixelRatio: number;
    statusBarHeight: number;
    navigationBarHeight: number;
}

/**
 * Provides display metrics for tracking and analytics.
 * Computes metrics on-demand to capture current viewport state
 * (e.g., if app is resized or rotated).
 */
export class DisplayMetricsProvider {
    static inject = () => [DeviceStatusBar];

    constructor(private statusBar: DeviceStatusBar){}

    getMetrics = (): IDisplayMetrics => {
        return {
            screen: {
                width: window.screen.width,
                height: window.screen.height,
            },
            viewport: {
                width: window.innerWidth,
                height: window.innerHeight
            },
            devicePixelRatio: window.devicePixelRatio,
            statusBarHeight: this.statusBar.getHeight(),
            navigationBarHeight: this.statusBar.getNavigationBarHeight()
        };
    };

}
